<template>
  <UFooter>
    <template #left>
      <div
        class="flex flex-col sm:flex-row sm:items-center w-full text-sm text-gray-500 dark:text-gray-400"
      >
        <span class="mb-2 sm:mb-0">
          Copyright © {{ new Date().getFullYear() }} <AppBrand />. All rights
          reserved.</span
        >
        <span class="hidden sm:inline mx-2">•</span>
        <div class="flex items-center">
          <NuxtLink
            to="/privacy"
            class="hover:text-primary-600 dark:hover:text-primary-400"
          >
            Privacy Policy
          </NuxtLink>
          <span class="mx-2">•</span>
          <NuxtLink
            to="/terms"
            class="hover:text-primary-600 dark:hover:text-primary-400"
          >
            Terms of Service
          </NuxtLink>
        </div>
      </div>
    </template>

    <template #right>
      <div class="flex items-center gap-2">
        <UButton
          to="https://www.linkedin.com/groups/1788071/"
          target="_blank"
          icon="i-simple-icons-linkedin"
          aria-label="LinkedIn"
          color="gray"
          variant="ghost"
        />
        <UButton
          to="https://x.com/aeronewsletter"
          target="_blank"
          icon="i-simple-icons-x"
          aria-label="X (Twitter)"
          color="gray"
          variant="ghost"
        />
        <UButton
          to="https://instagram.com/aeronewsletter"
          target="_blank"
          icon="i-simple-icons-instagram"
          aria-label="Instagram"
          color="gray"
          variant="ghost"
        />
      </div>
    </template>
  </UFooter>
</template>
